var module = angular.module('octopusApp.configuration');

module.directive('masterKeyClippy', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    templateUrl: 'areas/configuration/views/master_key_clippy.html',
    controller: function($scope, $state, octopusRepository) {
      octopusRepository.Backups.getConfiguration().then(function(backup){
        $scope.backup = backup;
      });

      $scope.okayIveDoneThis = function() {
        $scope.backup.IsMasterKeyBackedUp = true;
        octopusRepository.Backups.updateConfiguration($scope.backup).then(function(backup){
          $scope.backup = backup;
          $state.reload();
        });
      };
    }
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/directives/master_key_clippy.js
// module id = 7577427740561144
// module chunks = 1